export default function LoadingState() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-primary-50 dark:bg-primary-950">
      <div className="animate-pulse h-8 w-32 bg-primary-200 dark:bg-primary-800" />
    </div>
  );
}
